export default function useMouseSvg(e) {
  const elem = e.currentTarget.closest("svg");
  /**
   * transform matrix to transform screen(client)-space to svg-space
   */
  const transform = elem.getScreenCTM().inverse();
  const point = elem.createSVGPoint();

  /**
   * convert to and return mouse position on target svg canvas
   * @param {event} event - MouseEvent to get the screen coordinate from
   */
  const pos = event => {
    point.x = event.clientX;
    point.y = event.clientY;

    return point.matrixTransform(transform);
  };

  return {
    pos
  };
}
